import angular from 'angular';
import 'angular-i18n/angular-locale_hu-hu';
import common from '../../common/common';
import colFilter from '../../modules/filter/colFilter';
import eszkozKalkulator from '../../applications/kalkulator/eszkozkalkulator/eszkozkalkulator';
import gazdalkodasiKalkulator from '../../applications/kalkulator/gazdalkodasikalkulator/gazdalkodasikalkulator';
import hirekKereso from '../../applications/hirek/hirek-kereso/hirek-kereso';
import hirekListazo from '../../applications/hirek/hirek-listazo/hirek-listazo';
import hirekMorzsamenu from '../../applications/hirek/hirek-reszletes/hirek-morzsamenu';
import hirekReszletes from '../../applications/hirek/hirek-reszletes/hirek-reszletes';
import kapcsolat from '../../applications/kapcsolat/kapcsolat';
import kereso from '../../applications/kereso/kereso/kereso';
import nyeremenyjatek from '../../applications/nyeremenyjatek/nyeremenyjatek';
import nyeremenyjatekFeliratkozas from '../../applications/nyeremenyjatek-feliratkozas/nyeremenyjatek-feliratkozas';
import nyeremenyjatekKerdesek from '../../applications/nyeremenyjatek-kerdesek/nyeremenyjatek-kerdesek';
import nyeremenyjatekOsszegzo from '../../applications/nyeremenyjatek-osszegzo/nyeremenyjatek-osszegzo';
import rendezvenyekKereso from '../../applications/rendezvenyek/rendezvenyek-kereso/rendezvenyek-kereso';
import szakertok from '../../applications/szakertok/szakertok';
import tamogatasKalkulator from '../../applications/kalkulator/tamogataskalkulator/tamogataskalkulator';
import termofoldKalkulator from '../../applications/kalkulator/termofoldkalkulator/termofoldkalkulator';
angular.module('AALT-app', [
	common,
	colFilter,
	eszkozKalkulator,
	gazdalkodasiKalkulator,
	hirekKereso,
	hirekListazo,
	hirekMorzsamenu,
	hirekReszletes,
	kapcsolat,
	kereso,
	nyeremenyjatek,
	nyeremenyjatekFeliratkozas,
	nyeremenyjatekKerdesek,
	nyeremenyjatekOsszegzo,
	rendezvenyekKereso,
	szakertok,
	tamogatasKalkulator,
	termofoldKalkulator
]).constant('environment', window.__env).config(function ($locationProvider) {
	'ngInject';
	$locationProvider.hashPrefix('');
});
angular.bootstrap(document, ['AALT-app']);



// WEBPACK FOOTER //
// ./source/layouts/AALT/layout.js